"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRcodeInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQrReader = require("react-qr-reader");
require("./styles.scss");
var _qrScannerDenied = _interopRequireDefault(require("./../assets/qr-scanner-denied.png"));
var _frame = _interopRequireDefault(require("./../assets/frame.svg"));
var _api = require("../api");
var _common = require("../../teacherDashboard/teacher/config/common");
var _QRcodePopup = _interopRequireDefault(require("./QRcodePopup"));
var _state = require("../state");
var _pushEventToGTM = require("../../commonHelpers/pushEventToGTM");
var _switchCamera = require("./switchCamera");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LiveStream = null;
var shouldReload = true;
function isShortURL(inputString) {
  // Regular expression to match URLs  includes "slearn.me"
  var urlPattern = /^.*slearn\.me.*/;
  return urlPattern.test(inputString);
}
function isURL(inputString) {
  if (!inputString) return false;
  try {
    new URL(inputString); // If valid, it won't throw an error
    return true;
  } catch (_unused) {
    return false; // If invalid, it throws an error
  }
}

var QRcodeInput = function QRcodeInput(_ref) {
  var _ref$setHasCameraAcce = _ref.setHasCameraAccess,
    setHasCameraAccess = _ref$setHasCameraAcce === void 0 ? function (val) {} : _ref$setHasCameraAcce;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    showQRPopup = _useAuthSigninState.showQRPopup,
    setShowQRPopup = _useAuthSigninState.setShowQRPopup,
    getFromPage = _useAuthSigninState.getFromPage;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    scannerError = _useState4[0],
    setScannerError = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    success = _useState10[0],
    setSuccess = _useState10[1];
  var handleScan = function handleScan(data, err) {
    shouldReload = false;
    if (data) {
      setResult(data.text);
      if (data !== null && data !== void 0 && data.text) {
        setLoading(true);
        setSuccess(null);
        setError(null);
        setShowQRPopup(false);
        trackEventsForGuests("Class Login Attempted", _objectSpread({
          "mp_login_user_type": "student",
          "Login Method": "QR code"
        }, (data === null || data === void 0 ? void 0 : data.text) && isURL(data === null || data === void 0 ? void 0 : data.text) && {
          "Resolved URL": data === null || data === void 0 ? void 0 : data.text
        }), {
          send_mixpanel: true
        });
        if (isShortURL(data === null || data === void 0 ? void 0 : data.text)) {
          (0, _common.SetCookie)('qr_code_login_flow', "true", 1000 * 60 * 60 * 24 * 365);
          window.location.href = data === null || data === void 0 ? void 0 : data.text;
          return;
        }
        _api.APIS.qrCodeLogin(data === null || data === void 0 ? void 0 : data.text).then(function (res) {
          var _res$data;
          (0, _pushEventToGTM.pushEventToGTM)('logged_in', {
            user_type: 'student',
            label: 'qr code login'
          });
          setSuccess("Great job!");
          setTimeout(function () {
            return setLoading(false);
          }, 3000);
          window.location.href = "".concat(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.redirect_to, "?loginMethod=QR code&fromPage=QR code scan input screen");
        })["catch"](function (e) {
          var _e$response, _e$response$data;
          setError((e === null || e === void 0 ? void 0 : (_e$response = e.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.error) || "Oops, try again!");
          setShowQRPopup(true);
        });
      }
    }
    if ((err === null || err === void 0 ? void 0 : err.name) === "NotAllowedError") {
      setScannerError(err);
    }
  };
  (0, _react.useEffect)(function () {
    onRequestCamera(true);
    return function () {
      if (LiveStream) {
        var _LiveStream, _LiveStream$getTracks;
        (_LiveStream = LiveStream) === null || _LiveStream === void 0 ? void 0 : (_LiveStream$getTracks = _LiveStream.getTracks()) === null || _LiveStream$getTracks === void 0 ? void 0 : _LiveStream$getTracks.forEach(function (track) {
          track === null || track === void 0 ? void 0 : track.stop();
          track.enabled = false;
        });
      }
      if (shouldReload) {
        trackAnalyticsEvent('Viewed QR Code Screen Ignored Camera Access', {
          'Intent for': 'login',
          'Screen type': 'page',
          'From Page': 'signin'
        }, true);
        setTimeout(function () {
          return window.location.reload();
        }, 0);
      }
    };
  }, []);
  var onRequestCamera = function onRequestCamera(sendEvent, showAlert) {
    shouldReload = true;
    var constraints = {
      audio: false,
      video: {
        facingMode: _switchCamera.VideoFacingMode.environment
      }
    };
    setLoading(true);
    navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
      shouldReload = false;
      LiveStream = stream;
      setLoading(false);
      setScannerError(null);
      setHasCameraAccess(true);
      if (sendEvent) {
        trackEventsForGuests("Viewed QR Code Input Screen Camera Access", {
          "mp_login_user_type": "student",
          "From page": getFromPage() || "Direct URL entered"
        }, {
          send_mixpanel: true
        });
        (0, _pushEventToGTM.pushEventToGTM)('viewed_qr_code_screen_camera_access', {
          'Intent for': 'login',
          'Screen type': 'page',
          'From Page': 'signin'
        });
      }
    })["catch"](function (e) {
      shouldReload = false;
      setLoading(false);
      if (sendEvent) {
        trackEventsForGuests("Viewed QR Code Input Screen No Camera Access", {
          "mp_login_user_type": "student",
          "From page": getFromPage() || "Direct URL entered"
        }, {
          send_mixpanel: true
        });
        (0, _pushEventToGTM.pushEventToGTM)('viewed_qr_code_screen_no_camera_access', {
          'Intent for': 'login',
          'Screen type': 'page',
          'From Page': 'signin'
        });
      }
      setScannerError(e);
      setHasCameraAccess(false);
      if (showAlert) {
        setTimeout(function () {
          alert("Your camera access is blocked. You need to manually provide permission and reload page.");
        }, 0);
      }
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_switchCamera.SwitchCamera, {
    "data-sentry-element": "SwitchCamera",
    "data-sentry-component": "QRcodeInput",
    "data-sentry-source-file": "QRcodeInput.tsx"
  }, function (_ref2) {
    var switchCamera = _ref2.switchCamera,
      currentDeviceId = _ref2.currentDeviceId,
      deviceCount = _ref2.deviceCount,
      facingMode = _ref2.facingMode;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "qr-code-input"
    }, scannerError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "qr-scanner-denied"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _qrScannerDenied["default"]
    }), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconWarning"
    }), /*#__PURE__*/_react["default"].createElement("label", null, "Allow camera access"))), isLoading && !scannerError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "qr-scanner-denied"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _qrScannerDenied["default"]
    }), shouldReload && /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconWarning"
    }), /*#__PURE__*/_react["default"].createElement("label", null, "Allow camera access"))), !scannerError && !isLoading && /*#__PURE__*/_react["default"].createElement("div", null, currentDeviceId ? /*#__PURE__*/_react["default"].createElement(_reactQrReader.QrReader, {
      key: currentDeviceId,
      className: "qr-reader",
      scanDelay: 300,
      onResult: handleScan,
      constraints: {
        facingMode: facingMode,
        deviceId: currentDeviceId
      }
    }) : /*#__PURE__*/_react["default"].createElement(_reactQrReader.QrReader, {
      key: facingMode,
      className: "qr-reader",
      scanDelay: 300,
      onResult: handleScan,
      constraints: {
        facingMode: facingMode
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "frame ".concat(success ? "success" : "")
    }, /*#__PURE__*/_react["default"].createElement(_frame["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
      className: "scanner"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "info"
    }, isLoading && !error && !success && result && /*#__PURE__*/_react["default"].createElement("div", {
      className: "loading"
    }, "Checking your QR code\u2026"), error && /*#__PURE__*/_react["default"].createElement("div", {
      className: "error"
    }, error), success && /*#__PURE__*/_react["default"].createElement("div", {
      className: "success"
    }, success)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-capture-msg"
    }, "The process of scanning the QR code does not capture any image, video, or other personal information. The process only reads the information contained in the QR code, which does not include any personal information."), scannerError && /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        onRequestCamera(true, true);
        trackEventsForGuests("Interacted QR code Input Screen No Camera Access", {
          "mp_login_user_type": "student",
          "Clicked on": "Allow camera access"
        }, {
          send_mixpanel: true
        });
      },
      className: "allow-camera-access"
    }, "Allow camera access"), !scannerError && deviceCount > 1 && /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        switchCamera();
        trackEventsForGuests("Interacted QR code Input Screen Camera Access", {
          "mp_login_user_type": "student",
          "Clicked on": "Switch Camera"
        }, {
          send_mixpanel: true
        });
      },
      className: "allow-camera-access"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconSync2"
    }), "Switch Camera"), showQRPopup ? /*#__PURE__*/_react["default"].createElement(_QRcodePopup["default"], {
      errorInfo: error,
      setLoading: setLoading,
      setError: setError
    }) : null);
  });
};
exports.QRcodeInput = QRcodeInput;